export const SOCKET_INIT = 'init';
export const SOCKET_RECONNECT = 'inCall';
export const SOCKET_REFRESH = 'refresh';
export const roomId = 'preflightTest';
export const streamTimeout = 5000;
export const testTimeOut = 15000;
export const statsIterationTimer = 5000;
